/* ZSportsTech — section-range.js
   Full-width product-card carousel as a sliding filmstrip belt.
   "Next" slides the belt left → new card enters from the right (matches arrows).
   Seamless forward loop via a cloned first slide. Arrows · tabs · swipe · auto-advance.
   Vanilla JS only. Maps to → assets/section-range.js */
(function () {
  'use strict';

  function init() {
    var section = document.getElementById('sc-range');
    if (!section) return;

    var track   = section.querySelector('.sc-range__track');
    var viewport= section.querySelector('.sc-range__viewport');
    var slides  = Array.prototype.slice.call(section.querySelectorAll('.sc-range__slide'));
    var tabs    = Array.prototype.slice.call(section.querySelectorAll('.sc-range__tab'));
    var prevBtn = section.querySelector('.sc-range__arrow.prev');
    var nextBtn = section.querySelector('.sc-range__arrow.next');
    var counter = section.querySelector('.sc-range__counter');
    var fill    = section.querySelector('.sc-range__progress-fill');
    var n = slides.length;
    if (!n || !track) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var INTERVAL = parseInt(section.getAttribute('data-autoplay') || '5000', 10);

    /* Clone the first slide and append — lets the belt roll forward past the
       last card into a copy of the first, then snap back invisibly. */
    var clone = slides[0].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-clone', '1');
    track.appendChild(clone);

    var pos = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    var animating = false;
    var finalizeTimer = null;

    function pad(x) { return (x < 10 ? '0' : '') + x; }
    function logical() { return ((pos % n) + n) % n; }

    function place(animate) {
      track.classList.toggle('no-anim', !animate || reduce);
      track.style.transform = 'translateX(' + (-pos * 100) + '%)';
    }

    function syncUI() {
      var L = logical();
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === L);
        s.setAttribute('aria-hidden', i === L ? 'false' : 'true');
      });
      tabs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === L);
        t.setAttribute('aria-selected', i === L ? 'true' : 'false');
      });
      if (counter) counter.textContent = pad(L + 1) + ' / ' + pad(n);
    }

    function finalize() {
      if (finalizeTimer) { clearTimeout(finalizeTimer); finalizeTimer = null; }
      if (!animating) return;   /* run exactly once per move */
      animating = false;
      if (pos >= n) {           /* landed on the clone → snap to the real first */
        pos = 0;
        place(false);
        void track.offsetWidth; /* force reflow so the snap is instant */
      }
      syncUI();
      startAuto();
    }

    function move(toPos) {
      if (animating) return;
      animating = true;
      pos = toPos;
      place(true);
      syncUI();
      if (reduce) { finalize(); return; }
      /* Guaranteed fallback — transitionend can be missed (backgrounded tab,
         equal-value transform, iframe quirks); never leave animating stuck. */
      finalizeTimer = setTimeout(finalize, 620);
    }

    function next() { move(pos + 1); }
    function prev() {
      if (animating) return;
      if (pos === 0) {          /* jump to the clone slot, then slide back to last */
        pos = n;
        place(false);
        void track.offsetWidth;
        move(n - 1);
      } else {
        move(pos - 1);
      }
    }
    function jump(target) {
      if (target === logical()) return;
      move(target);
    }

    track.addEventListener('transitionend', function (e) {
      if (e.target === track && e.propertyName === 'transform') finalize();
    });

    /* ── Progress fill + auto-advance ─────────────── */
    var rafId = null, startTs = 0, paused = false;
    function setFill(p) { if (fill) fill.style.width = (p * 100) + '%'; }
    function frame(ts) {
      if (paused) return;
      if (!startTs) startTs = ts;
      var e = ts - startTs;
      var L = logical();
      setFill((L + Math.min(e / INTERVAL, 1)) / n);
      if (e >= INTERVAL) { startTs = 0; next(); return; }
      rafId = requestAnimationFrame(frame);
    }
    function startAuto() {
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      startTs = 0;
      setFill(logical() / n);
      if (reduce) { setFill((logical() + 1) / n); return; }
      rafId = requestAnimationFrame(frame);
    }
    function pause() { paused = true; if (rafId) { cancelAnimationFrame(rafId); rafId = null; } }
    function resume() { if (!paused) return; paused = false; startTs = 0; if (!reduce) rafId = requestAnimationFrame(frame); }

    /* ── Controls ─────────────────────────────────── */
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { jump(i); }); });

    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
    });

    section.addEventListener('pointerenter', pause);
    section.addEventListener('pointerleave', resume);
    section.addEventListener('focusin', pause);
    section.addEventListener('focusout', resume);

    /* ── Swipe / drag ─────────────────────────────── */
    if (viewport) {
      var down = false, sx = 0, dx = 0;
      viewport.addEventListener('pointerdown', function (e) { down = true; sx = e.clientX; dx = 0; pause(); });
      window.addEventListener('pointermove', function (e) { if (down) dx = e.clientX - sx; });
      window.addEventListener('pointerup', function () {
        if (!down) return; down = false;
        if (Math.abs(dx) > 50) { if (dx < 0) next(); else prev(); }
        paused = false; resume();
      });
    }

    place(false);
    syncUI();
    startAuto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
}());
